import PollCard from "../pollCard";

export default function PollPost({ post }) {
  return <PollCard poll={post.poll} />;
}
